'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n   position: absolute;\n   top: ', 'px;\n   left: ', 'px;\n   width: ', 'px;\n   height: ', 'px;\n   background-image: url(', ');\n   background-size: contain;\n   background-repeat: no-repeat;\n '], ['\n   position: absolute;\n   top: ', 'px;\n   left: ', 'px;\n   width: ', 'px;\n   height: ', 'px;\n   background-image: url(', ');\n   background-size: contain;\n   background-repeat: no-repeat;\n ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/** @class ImageLayer
 * Renders a positioned image on the stage.
 * @prop {url} image - the image to display on stage
 * @prop {number} x - the horizontal position of the image on stage
 * @prop {number} y - the vertical position of the image on stage
 * @prop {number} width - the width of the image on stage
 * @prop {number} height - the height of the image on stage
 */
var ImageLayer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.y;
}, function (props) {
  return props.x;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.image;
});
exports.default = ImageLayer;


ImageLayer.propTypes = {
  image: _propTypes2.default.string.isRequired,
  x: _propTypes2.default.number.isRequired,
  y: _propTypes2.default.number.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/stage/image-layer.js
// module id = 519
// module chunks = 0